<template>
  <div>
    <b-card ref="container" id="container">
      <b-card-text class="mb-2">
        <h5>
          {{ $t('pages.voiceAlertSettings.desc') }}
        </h5>
      </b-card-text>
      <text-editor
        :key="0"
        :id="newMessage.id"
        :title="$t('pages.voiceAlertSettings.newMessage.title')"
        :desc="$t('pages.voiceAlertSettings.newMessage.desc')"
        :param-options="[
          {
            label: 'operator_name_desc',
            value: '{{operatorName}}'
          }
        ]"
        v-model.lazy="newMessage.options"
        @update:textEditor="onUpdateTextEditor"
        @update:enable="onUpdateEnable"
        class="mb-2"
      />

      <text-editor
        :key="1"
        :id="msgWhenOperatorReplyLate.id"
        :title="$t('pages.voiceAlertSettings.operatorLateResponse.title')"
        :desc="$t('pages.voiceAlertSettings.operatorLateResponse.desc')"
        :time-notify-desc="
          $t('pages.voiceAlertSettings.operatorLateResponse.notify.desc')
        "
        v-model.lazy="msgWhenOperatorReplyLate.options"
        :param-options="[
          {
            label: 'operator_name_desc',
            value: '{{operatorName}}'
          },
          {
            label: 'count_unread_desc',
            value: '{{countLateReplyMessage}}'
          },
          {
            label: 'channel_name_desc',
            value: '{{channelName}}'
          }
        ]"
        @update:textEditor="onUpdateTextEditor"
        @update:enable="onUpdateEnable"
        class="mb-2"
      />

      <text-editor
        :key="2"
        :id="msgWhenOperatorReplyMissed.id"
        :title="$t('pages.voiceAlertSettings.operatorMissedResponse.title')"
        :desc="$t('pages.voiceAlertSettings.operatorMissedResponse.desc')"
        :time-notify-desc="
          $t('pages.voiceAlertSettings.operatorMissedResponse.notify.desc')
        "
        v-model.lazy="msgWhenOperatorReplyMissed.options"
        :param-options="[
          {
            label: 'operator_name_desc',
            value: '{{operatorName}}'
          },
          {
            label: 'count_unread_desc',
            value: '{{countLateReplyMessage}}'
          },
          {
            label: 'channel_name_desc',
            value: '{{channelName}}'
          }
        ]"
        @update:textEditor="onUpdateTextEditor"
        @update:enable="onUpdateEnable"
        class="mb-2"
      />
    </b-card>
  </div>
</template>

<script>
  import { BCard, BCardText, BButton } from 'bootstrap-vue';
  import VoiceAlertSettingsRepository from '@/repositories/Api/VoiceAlertSettingsRepository';
  import Update from './QuickMessage/Update.vue';
  import ChatAssignment from './ChatAssignment.vue';
  import TextEditor from './TextEditor.vue';

  export default {
    components: {
      BCard,
      BCardText,
      BButton,
      TextEditor,
      Update,
      ChatAssignment
    },

    data: () => ({
      data: [],
      newMessage: {
        id: '',
        title: '',
        desc: '',
        options: {
          enable: false,
          locales: {
            en: 'Hello',
            zh: '',
            km: '',
            vi: ''
          }
        }
      },
      msgWhenOperatorReplyLate: {
        id: '',
        title: '',
        desc: '',
        options: {
          sendAfter: 60,
          enable: false,
          locales: {
            en: 'Hello',
            zh: '',
            km: '',
            vi: ''
          }
        }
      },
      msgWhenOperatorReplyMissed: {
        id: '',
        title: '',
        desc: '',
        options: {
          enable: false,
          locales: {
            en: 'Hello',
            zh: '',
            km: '',
            vi: ''
          }
        }
      }
    }),
    methods: {
      async getAlertVoiceSettings() {
        try {
          const response = await VoiceAlertSettingsRepository.show();
          const { data } = response.data;

          this.data = data;
          this.newMessage = this.mappingData('action.voiceAlertNewMessage');
          this.msgWhenOperatorReplyLate = this.mappingData(
            'action.voiceAlertMerchantNoResponse'
          );
          this.msgWhenOperatorReplyMissed = this.mappingData(
            'action.voiceAlertEndByCustomer'
          );
        } catch (err) {
          const { data } = err.response;
          const { message } = data;
          if (message === 'error.recordNotFound')
            await this.createDefaultChatSettings();
        }
      },
      async createDefaultChatSettings() {
        try {
          await VoiceAlertSettingsRepository.show();
          await this.getAlertVoiceSettings();
        } catch (err) {
          alert(err);
        }
      },
      async updateVoiceAlertSettings(payloadUpdate, id) {
        try {
          const response = await VoiceAlertSettingsRepository.update(
            payloadUpdate,
            id
          );
        } catch (err) {
          alert(err);
        } finally {
          await this.getAlertVoiceSettings();
        }
      },
      async onUpdateEnable(event) {
        let payload = {
          enable: event.enable
        };
        this.updateVoiceAlertSettings(payload, event.id);
      },
      async onUpdateTextEditor(event) {
        let payload = {
          notifySend: event?.sendAfter,
          message: event.locales
        };
        this.updateVoiceAlertSettings(payload, event.id);
      },
      mappingData(codeAction) {
        let filterData = this.data.filter(item => {
          return item.code == codeAction;
        });
        let settingMsg = filterData[0];
        const code = 'action.voiceAlertMerchantNoResponse';

        let response = {
          id: settingMsg.id,
          title: settingMsg.title,
          desc: settingMsg.description,
          options: {
            enable: settingMsg.enable,
            sendAfter: codeAction == code ? settingMsg?.notifySend : undefined,
            locales: {
              en: settingMsg.message.en,
              zh: settingMsg.message.zh,
              km: settingMsg.message.km,
              vi: settingMsg.message.vi
            }
          }
        };
        if (codeAction == 'action.end') {
          delete response.options.sendAfter;
          response.options.closeTime = settingMsg.notifySend;
        } else if (codeAction == 'action.endManual') {
          delete response.options.sendAfter;
        }
        return response;
      }
    },
    mounted() {
      this.getAlertVoiceSettings();
    },
    setup() {
      const permissionType = 'voice-settings';
      return { permissionType };
    }
  };
</script>
<style lang="css" scoped>
:deep(textarea) {
  resize: none;
  width: 600px !important;
}
</style>